import(/* webpackMode: "eager" */ "/home/runner/work/pluswilla/pluswilla/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/pluswilla/pluswilla/src/components/contact-us/ContactForm.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/pluswilla/pluswilla/src/components/contact-us/Coverview.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/pluswilla/pluswilla/src/components/Highlights/Subbanner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/pluswilla/pluswilla/src/components/layout/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/pluswilla/pluswilla/src/components/layout/Header.tsx");
